export class User {
    isSelected: any;
    constructor(
        public isAdmin: boolean,
        public isAdminGlobal: boolean,
        public isDemo: boolean,
        public isActivatedByDefault: boolean,
        public id: string,
        public date: Date,
        public firstname: string,
        public lastname: string,
        public role: any,
        public rights: any[],
        public editableCategories: any,
        public email: string,
        public password: string,
        public address: string,
        public city: string,
        public zipCode: string,
        public mobile: string,
        public groups: any[],
        public children: any[],
        public secret: string,
        public appName: string,
        public receiveMessageAsMail: boolean,
        public outOfOffice: boolean,
        public outOfOfficeText: string,
        public tokens: any,
        public fields: any[],
        public messagesSentLast3Months: number,
        public description?: string,
        public temporaryUserId?: string,
        public isDeleted?: boolean,
        public disabled?: boolean,
    ) { }

    isTeacher() {
        if (this.role && this.role.type === 'teacher') {
            return true;
        }
        if (this.rights && this.rights.length) {
            for (const right of this.rights) {
                if (right.role.type === 'teacher') {
                    return true;
                }
            }
        }
        return false;
    }

    isParent() {
        if (this.role && this.role.type === 'parent') {
            return true;
        }
        if (this.rights && this.rights.length) {
            for (const right of this.rights) {
                if (right.role.type === 'parent') {
                    return true;
                }
            }
        }
        return false;
    }

    canEditUserFields() {
        if (this.role && this.role.canEditUserFields) {
            return true;
        }
        if (this.rights && this.rights.length) {
            for (const right of this.rights) {
                if (right.role.canEditUserFields) {
                    return true;
                }
            }
        }
        return false;
    }

    can(field: string) {
        if (this.role && this.role[field] === true) {
            return true;
        }
        if (this.rights && this.rights.length) {
            for (const right of this.rights) {
                if (right.role[field] === true) {
                    return true;
                }
            }
        }
        return false;
    }
    
    canNot(field: string) {
        if (this.role && this.role[field] === false) {
            return false;
        }
        if (this.rights && this.rights.length) {
            for (const right of this.rights) {
                if (right.role[field] === false) {
                    return false;
                }
            }
        }
        return true;
    }

    canGroup(field: string, groupId: string) {
        let hasGroup = false;
        for (let i = 0; i < this.groups.length; i++) {
            if (this.groups[i].id === groupId) {
                hasGroup = true;
            }
        }
        if (this.role && this.role[field] === true && hasGroup) {
            return true;
        }
        if (this.rights && this.rights.length) {
            for (const right of this.rights) {
                if (right.role[field] === true && right.group.id === groupId) {
                    return true;
                }
            }
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/users/shared/user.model.ts